import { render, staticRenderFns } from "./viewgift.vue?vue&type=template&id=0a9f3bfa&scoped=true&"
import script from "./viewgift.vue?vue&type=script&lang=js&"
export * from "./viewgift.vue?vue&type=script&lang=js&"
import style0 from "./viewgift.vue?vue&type=style&index=0&id=0a9f3bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9f3bfa",
  null
  
)

export default component.exports